import { GET_ADVICES, CREATE_ADVICE, CONFIRM_ADVICE, DELETE_ADVICE } from "./types";

const initialState = {
    advices: [],
    changedAdvice: null,
};

export const adviceReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ADVICES:
            return { ...state, advices: action.payload };
        case CREATE_ADVICE:
            return { ...state, advices: [action.payload, ...state.advices] };
        case CONFIRM_ADVICE:
            return { ...state, changedAdvice: action.payload };
        case DELETE_ADVICE:
            return {
                ...state,
                advices: state.advices.filter((advice) => advice._id !== action.payload),
            };
        default:
            return state;
    }
};
